import { render, staticRenderFns } from "./logistics-details.vue?vue&type=template&id=5c53174c&"
import script from "./logistics-details.vue?vue&type=script&lang=js&"
export * from "./logistics-details.vue?vue&type=script&lang=js&"
import style0 from "./logistics-details.vue?vue&type=style&index=0&id=5c53174c&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c53174c')) {
      api.createRecord('5c53174c', component.options)
    } else {
      api.reload('5c53174c', component.options)
    }
    module.hot.accept("./logistics-details.vue?vue&type=template&id=5c53174c&", function () {
      api.rerender('5c53174c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nb/supplyChain/delivery/components/logistics-details.vue"
export default component.exports